import { TextField } from "../../ui";
import React, { useEffect, useState } from "react";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import DialogBox from "../../global/DialogBox";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { useRestoBillActions } from "../../global/hooks/useRestoBillActions";
import { useSelector } from "react-redux";

const InitiatePaymentWhatsAppDialog = ({
  title = "Initiate Payment",
  showDialog,
  setShowDialog,
}) => {
  const { snackbar } = useSnpUI();
  const {
      initiatePayment
  } = useRestoBillActions();

    const { billCustomerDetails } = useSelector(
      (state) => state.bill
    );
  const [whatsappNumber, setWhatsappNumber] = useState("");

  useEffect(() => {
    if (billCustomerDetails?.custMob) {
      setWhatsappNumber(billCustomerDetails.custMob);
    } 
  }, [billCustomerDetails]);

  const isValidNumber = (num) => {
    return /^[6-9]\d{9}$/.test(num);
  };

  const handleSubmit = () => {
    if (!whatsappNumber || !isValidNumber(whatsappNumber)) {
      snackbar.show({
        message: "Please enter valid WhatsApp number",
        color: "red"
      });
      return;
    }

    initiatePayment(false, true, whatsappNumber);

    // reset + close
    setShowDialog(false);
    //setWhatsappNumber("");
  };

  // ---------------- UI ---------------- //
  const buildContent = () => {
    return (
      <TextField
        id="whatsapp-number"
        name="whatsappNumber"
        variant="filled"
        size="small"
        label="Enter WhatsApp Number"
        value={whatsappNumber}
        onChange={(e) => setWhatsappNumber(e.target.value)}
        inputProps={{
          maxLength: 10
        }}
        fullWidth
      />
    );
  };

  const buildActions = () => {
    return (
      <>
        <SnpButton
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          {title}
        </SnpButton>

        <DismissButton
          variant="contained"
          color="primary"
          onClick={() => {
            setShowDialog(false);
            // setWhatsappNumber("");
          }}
        >
          Dismiss
        </DismissButton>
      </>
    );
  };

  return (
    <DialogBox
      showDialog={showDialog}
      title={title}
      dialogContent={buildContent()}
      dialogActions={buildActions()}
    />
  );
};

export default InitiatePaymentWhatsAppDialog;